// extracted by mini-css-extract-plugin
module.exports = {"similar":"_93444fe79c--similar--3t-gZ","similar-title":"_93444fe79c--similar-title--1frl4","similar-item":"_93444fe79c--similar-item--3VBDZ"};